export default __webpack_public_path__ + "static/media/image.edugene.be61327a.png";